import DesignSystem from 'design-system-utils';
import containerWidth from 'common/consts/containerWidth';
import { media, isOnMobile } from 'common/responsive';
import { NAV_HEIGHT } from 'common/consts/navigation';

export const myDesignSystem = {
  type: {
    // this should be set as a px value if you have `options.fontSizeUnit` set
    // to 'rem' or 'em' so that the lib can convert the values properly
    baseFontSize: '16px',
    // Used with `ds.fontSize(value)` / `ds.fs(value)`
    sizes: {
      xs: '11px',
      s: '13px',
      base: '17px',
      m: '19px',
      l: '30px',
      xl: '50px',
      xxl: '70px',
      blogArticleParagraph: '22px',
    },
    // use with ds.get('type.fontFamily.value')
    fontFamily: {
      headline: 'Poppins',
      text: 'Roboto',
    },
    // use with ds.get('type.fontWeight.value')
    fontWeight: {
      light: 300,
      regular: 400,
      extended: 500,
      bold: 700,
    },
    // use with ds.get('type.lineHeight.value')
    lineHeight: {
      xs: '13px',
      s: '25px',
      base: '26px',
      l: '40px',
      xl: '60px',
      xxl: '80px',
    },
  },
  // Color palette
  // Each object needs to have the same shape
  // Each color object needs a `base` value to be the default
  // Have as many color objects as you like
  colors: {

    // Used with `ds.brand('social', 'colorName')`
    colorPalette: {
      social: {
        fb: '#3B5998',
        tw: '#00ACED',
        link: '#007FB1',
      },
    },
    // Used with `ds.brand('colorName)`
    brand: {
      product: '#3146FF',
      productHover: '#2e40f0',
      productActive: '#2d3fe1',
      text: '#000000',
      background: '#f7f7f7',
      darkBackground: '#ECEFF3',
      darkPurple: '#6450d6',
      secondary: '#01ffcb',
      white: '#ffffff',
      regular: '#000000',
    },
  },
  // used with `ds.get('metrics.value)`
  metrics: {
    xs: '12px',
    s: '20px',
    base: '30px',
    m: '40px',
    l: '60px',
    xl: '90px',
    xxl: '120px',
    textEnlarge: 1.1,
  },

  // few elements in navigation section uses same
  // height to be match in element.
  navSection: {
    navHeight: `${NAV_HEIGHT}px`,
  },
};

export default new DesignSystem(myDesignSystem, {
  fontSizeUnit: 'rem',
});

export { containerWidth, media, isOnMobile };



// WEBPACK FOOTER //
// ./src/designsystem/index.js